/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Button, Modal, Space, Tag } from 'antd';
import useListFilters from '../../hooks/useListFilters';
import ListPage from '../core/ListPage';
import EditRadiologist from './EditRadiologist';
import AddRadiologist from './AddRadiologist';
import { useAllRadiologistList } from '../../hooks/radiologists/useAllRadiologistsList';
const BREAD_CRUMBS = [
  { label: 'Radiologist', to: '/user/radiologistlist' },
  { label: 'List', to: '/user/radiologistlist' },
];

const RadiologistList = () => {
  const formRef = useRef(null);
  const { data, getList } = useAllRadiologistList();
  const {
    search,
    setSearch,
    pagination,
    setPagination,
    sortParams,
    setSortParams,
    loading,
    setLoading,
    selectedRows,
    setSelectedRows,
  } = useListFilters();
  const [editRecord, setEditRecord] = useState();
  const [show, setShow] = useState(false);

  // modal
  const showModal = () => setShow(true);
  const hideModal = () => {
    formRef?.current?.reset?.();
    setShow(false);
    setEditRecord(undefined);
  };
  const handleCancel = () => {
    hideModal();
  };
  const handleSuccess = () => {
    hideModal();
    reload();
  };
  const handleError = () => {};

  // Table
  const handleAdd = () => showModal();
  const handleEdit = (record) => {
    if (record?.associationType !== 'clinicUser') return;
    showModal();
    let data;
    data = {
      userSub: record?.sub,
      firstName: record?.firstName,
      lastName: record?.lastName,
      nameTitle: record?.nameTitle,
      email: record?.email,
      mobile: record?.mobile,
      status: record?.status,
    };

    setEditRecord(data);
  };

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getList({
        search,
        page: pagination.current,
        limit: pagination.pageSize,
        sortOrder: sortParams.sortOrder,
        sortBy: sortParams.sortField,
      });
      setLoading(false);
      setPagination({ total: response.totalItems });
    } catch (error) {
      setLoading(false);
    }
  }, [
    pagination.current,
    pagination.pageSize,
    sortParams.sortOrder,
    sortParams.sortField,
    search,
  ]);
  const handleTableChange = (newPagination, _, sorter) => {
    const newSortOrder = Array.isArray(sorter) ? undefined : sorter.order;
    const newSortField = Array.isArray(sorter) ? undefined : sorter.field;

    const pageSizeChanged = newPagination?.pageSize !== pagination.pageSize;
    const sortChanged =
      newSortOrder !== sortParams.sortOrder ||
      newSortField !== sortParams.sortField;

    const resetPage = pageSizeChanged || sortChanged;
    const resolvedPage = resetPage ? 1 : (newPagination?.current || 1);

    setSortParams({ sortOrder: newSortOrder, sortField: newSortField });
    setPagination({ current: resolvedPage, pageSize: newPagination?.pageSize });
  };

  const handleSearch = (searchValue) => {
    setSearch(searchValue);
  };

  useEffect(() => {
    reload();
  }, [
    pagination.current,
    pagination.pageSize,
    sortParams.sortOrder,
    sortParams.sortField,
    search,
  ]);

  const columns = [
    {
      title: 'Name',
      dataIndex: 'fullName',
      sorter: true,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      sorter: true,
    },
    {
      title: 'Contact No.',
      dataIndex: 'mobile',
      sorter: true,
    },
    {
      title: 'Registered',
      dataIndex: 'associationType',
      render: (_, { associationType }, index) => {
        let color = associationType == 'clinicUser' ? 'green' : 'geekblue';
        let status = associationType == 'clinicUser' ? 'Done' : 'Pending';
        return (
          <Tag color={color} key={status}>
            {status.toUpperCase()}
          </Tag>
        );
      },
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      render: (_, { status, associationType }, index) => {
        let color = status ? 'green' : 'geekblue';
        let _status = status ? 'Active' : 'InActive';

        if (associationType === 'clinicUser') {
          return (
            <Tag color={color} key={_status}>
              {_status}
            </Tag>
          );
        }
        return '-';
      },
    },
    {
      title: '',
      dataIndex: '',
      render: (text, record) => (
        <Space size="middle">
          <Button
            key="ok"
            type="primary"
            disabled={record?.associationType !== 'clinicUser'}
            onClick={() => handleEdit(record)}
          >
            Edit
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <>
      <ListPage
        title={'Radiologist List'}
        data={data?.items || []}
        columns={columns}
        loading={loading}
        pagination={pagination}
        rowKey={(record) => record?.email}
        onAdd={handleAdd}
        onRefresh={reload}
        onSearch={handleSearch}
        onTableChange={handleTableChange}
        breadCrumbItems={BREAD_CRUMBS}
        onSelectRowsfun={setSelectedRows}
        showCheckbox={false}
      />
      <Modal
        title={editRecord ? 'Edit Radiologist' : 'Add Radiologist'}
        open={show}
        onCancel={handleCancel}
        maskClosable={false}
        footer={null}
      >
        {editRecord ? (
          <EditRadiologist
            ref={formRef}
            formValues={editRecord ?? {}}
            onSuccess={handleSuccess}
            onError={handleError}
          />
        ) : (
          <AddRadiologist
            ref={formRef}
            onSuccess={handleSuccess}
            onError={handleError}
          />
        )}
      </Modal>
    </>
  );
};

export default RadiologistList;
